/**
 * Utility to detect if the application is running in a WebView environment
 */

/**
 * Detects if the current environment is a React Native WebView
 * @returns boolean indicating if we're in a React Native WebView
 */

interface BeCreativesWindowConfig {
  beCreativesConfig?: {
    isWebView?: boolean;
    brandId?: string;
    isCreateRequest?: boolean;
    brainTab?: string;
  };
}

export const getWebviewConfig = () => {
  return (window as BeCreativesWindowConfig)?.beCreativesConfig;
};

export const getBrandIdFromWebviewConfig = () => {
  return getWebviewConfig()?.brandId;
};

export const getIsCreateRequestFromWebviewConfig = () => {
  return getWebviewConfig()?.isCreateRequest;
};

export const getBrainTabFromWebviewConfig = () => {
  return getWebviewConfig()?.brainTab;
};

export const isReactNativeWebView = (): boolean => {
  // Check for specific properties that React Native WebView might inject
  if (typeof window === 'undefined') {
    return false;
  }

  // Check for ReactNativeWebView object
  const hasWebViewObject: boolean = 'ReactNativeWebView' in window;
  const isBeCreativesWebView = !!(window as BeCreativesWindowConfig)?.beCreativesConfig?.isWebView;

  // Check for WebView in user agent
  let hasWebViewUserAgent = false;
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    hasWebViewUserAgent = /wv|ReactNativeWebView/.test(navigator.userAgent);
  }

  return (hasWebViewObject || hasWebViewUserAgent) && isBeCreativesWebView;
};

/**
 * Detects if we have a message channel established with a parent React Native app
 * @returns boolean indicating if communication channel is available
 */
export const hasReactNativeMessageChannel = (): boolean => {
  return typeof window !== 'undefined' && 'ReactNativeWebView' in window;
};
